import React from 'react';

function FormActionRow(props) {
  const {
    onBack,
    backLabel = '上一步',
    nextLabel,
    nextType = 'submit',
    onNext,
    disabled,
    loading,
    nextClassName = 'bg-primary',
    className = '',
  } = props;

  const isDisabled = !!disabled || !!loading;
  const buttonClassName = 'w-[9.5rem] sm:w-[10.5rem] h-14 rounded-full text-white text-lg sm:text-xl whitespace-nowrap leading-none flex items-center justify-center shrink-0';

  return (
    <div className={`flex justify-center gap-4 mt-9 mb-4 ${className}`.trim()}>
      {onBack && (
        <button
          type="button"
          onClick={onBack}
          disabled={isDisabled}
          className={`${buttonClassName} bg-alto ${isDisabled ? 'opacity-70 cursor-not-allowed' : ''}`.trim()}
        >
          {backLabel}
        </button>
      )}
      <button
        type={nextType}
        onClick={onNext}
        disabled={isDisabled}
        className={`${buttonClassName} ${isDisabled ? 'bg-mercury' : nextClassName}`.trim()}
      >
        {nextLabel}
      </button>
    </div>
  );
}

export default FormActionRow;
